export default "__VITE_ASSET__YIYWdmJ8__"